const IMAGE_RESOLUTIONS = ['1K', '2K', '4K'];

const getGenerationCreditCost = (resolution = '1K') => {
  if (!IMAGE_RESOLUTIONS.includes(resolution)) {
    throw new Error('Image resolution must be 1K, 2K or 4K');
  }
  return resolution === '4K' ? 3 : resolution === '2K' ? 2 : 1;
};

const getGenerationCreditUsage = ({ limit, count, balance, cost }) => {
  const isUnlimited = limit === 'Unlimited';
  const includedCreditsLeft = isUnlimited ? Infinity : Math.max(0, limit - count);
  const purchasedCreditsToUse = Math.max(0, cost - includedCreditsLeft);

  return {
    isUnlimited,
    includedCreditsLeft,
    extraCreditsLeft: balance,
    purchasedCreditsToUse,
    canGenerate: purchasedCreditsToUse <= balance,
  };
};

module.exports = { IMAGE_RESOLUTIONS, getGenerationCreditCost, getGenerationCreditUsage };
